<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="center1"><em>I will not cease from Mental Fight,<br/>Nor shall my Sword sleep in my hand:<br/>Till we have built Jerusalem,<br/>In England’s green &amp; pleasant Land</em></p>
<p class="center">William Blake<br/>‘Jerusalem’</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi1.vue?ad06dfcc